import "./new-waiver.scss";

import { FormProvider } from "react-hook-form";
import { FaChevronLeft } from "react-icons/fa6";
import { Button } from "primereact/button";

import HeaderContent from "@shared/ui/header-content/header-content";
import FormWaiver from "../form-waiver/form-waiver";
import { useNewWaiver } from "./new-waiver.hook";
import { useState } from "react";
import { Dialog } from "primereact/dialog";
import PrintWaiver from "@domain/contract/print-waiver/print-waiver";

export function NewWaiver() {
  const {
    isCreating,
    formMethod,
    description,
    subtitle,
    name,
    fontSize,
    navigate,
    handleSubmit,
    handleValidate,
    handleValidateError,
  } = useNewWaiver();
  const [previewWaiver, setPreviewWaiver] = useState(false);

  const printWaiver = (
    <Dialog
      header="Waiver Preview"
      visible={previewWaiver}
      style={{ width: "50vw" }}
      onHide={() => {
        if (!previewWaiver) return;
        setPreviewWaiver(false);
      }}
    >
      <PrintWaiver
        fontSize={fontSize || 11}
        subTitle={subtitle || ""}
        title={name || ""}
        session={0}
        patient="Patient Name"
        doctor="Doctor Name"
        service="Service Name"
        waiverText={description || ""}
        signature={null}
      />
    </Dialog>
  );

  return (
    <div id="NewWaiver" className="waiver">
      <HeaderContent
        title={<h1>New Waiver</h1>}
        backIcon={<FaChevronLeft />}
        onBack={() => navigate("../")}
      >
        <Button
          className="w-full block"
          label="Save"
          disabled={isCreating}
          onClick={handleSubmit(handleValidate, handleValidateError)}
        ></Button>
      </HeaderContent>

      <div className="p-7">
        <FormProvider {...formMethod}>
          {printWaiver}
          <section className="grid grid-cols-1 md:grid-cols-2 gap-2 mb-4">
            <FormWaiver handleWaiverPreview={() => setPreviewWaiver(true)} />
          </section>
        </FormProvider>
      </div>
    </div>
  );
}

export default NewWaiver;
